export default __webpack_public_path__ + "static/media/img8.e986e813.jpg";